module.exports = __webpack_public_path__ + "img/obd_logo.fb4f3d49.png";